import * as API from "middleware/api";

export const creditBillList = (params) => API.executeWithAccessToken("/fcem.invoice.list", { ...params });
export const creditBillsDetail = (data) => API.executeWithAccessToken(`/fcem.read.invoice.detail`, { ...data });
export const confirmCreditBills = (params) => API.executeWithAccessToken("/fcem.action", { ...params });

export const fcemAction = (params) => API.executeWithAccessToken("/fcem.action", { ...params });

export const beneficiaryList = (params) => API.executeWithAccessToken("/fcem.befeficiary.list", { ...params });
